import { App } from 'vue';
import Interceptor from './intersection.observer.vue';

export default async function config(app: App) {
    // eslint-disable-next-line vue/multi-word-component-names
    app.component('Interceptor', Interceptor);
}
